import { createTextFilter } from '@ipfabric/utils';
import type { Filters } from '@ipfabric/utils/table/filters/filters';
import { filterToConditions } from './RuleForm/ruleFilterMapping';
import { testColumnLabel } from './RuleForm/ruleFormSchema';
import type { RuleLabel } from './rulesApi';

export const formatRuleTargetLine = (condition: {
  property: string;
  operator: 'is' | 'isNot';
  regex: string;
}): string =>
  `${testColumnLabel(condition.property)}: ${condition.operator === 'isNot' ? '!' : ''}${condition.regex}`;

export const formatRuleTargetLines = (
  filter: Filters | null | undefined,
): string[] =>
  filterToConditions(filter).map((condition) =>
    formatRuleTargetLine(condition),
  );

export const formatRuleTargetSearchText = (
  filter: Filters | null | undefined,
): string => formatRuleTargetLines(filter).join('\n');

export const formatRuleLabelLine = (label: RuleLabel): string =>
  label.value ? `${label.name}: ${label.value}` : label.name;

export const formatRuleLabelLines = (labels: RuleLabel[]): string[] =>
  labels.map((label) => formatRuleLabelLine(label));

export const formatRuleLabelsSearchText = (labels: RuleLabel[]): string =>
  formatRuleLabelLines(labels).join('\n');

export const rulesTableTextFilter = createTextFilter();
